module.exports = "/_next/static/images/602d92e7eabb736608f4aa7fd1695e82-card-background-left-lg.jpg";